export type StringKeys<T> = {
    [K in keyof T]: T[K] extends string | undefined | null ? K : never;
  }[keyof T];
  
  export const serializablePropsAreEqual = <T, K extends keyof T>(
    obj1: T,
    obj2: T,
    props: K[]
  ): boolean =>
    props.every(prop => {
      const val1 = obj1[prop];
      const val2 = obj2[prop];
  
      if (val1 === val2) return true;
  
      if (typeof val1 === 'object' && val1 !== null && typeof val2 === 'object' && val2 !== null) {
        return JSON.stringify(val1) === JSON.stringify(val2);
      }
  
      return false;
    });

export const mapToStringProp = <T, K extends StringKeys<T>>(items: T[], prop: K): string[] =>
  items.map(item => (item[prop] as unknown as string) ?? '');

export const findById = <K extends string, T extends { id: K }>(items: T[], id: K): T | undefined => items.find(item => item.id === id);